import { render, staticRenderFns } from "./PopupRemoveDislikes.vue?vue&type=template&id=c5ec494e&scoped=true"
import script from "./PopupRemoveDislikes.vue?vue&type=script&lang=js"
export * from "./PopupRemoveDislikes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ec494e",
  null
  
)

export default component.exports